module.exports = __webpack_public_path__ + "images/fd6c2b7f42f32e136de7018731a5f53d.png";